import React from 'react';
interface ButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  children: React.ReactNode;
  className?: string;
}
export function Button({
  children,
  className = '',
  ...props
}: ButtonProps) {
  return <button className={`glass-button px-8 py-4 text-sm tracking-[0.2em] uppercase font-medium rounded-sm ${className}`} {...props} data-id="element-26">
      {children}
    </button>;
}